export const mapboxToken = 'pk.eyJ1Ijoiam9lcmFpaSIsImEiOiJjbDhlbjFwZDIwYXBnM29tanA3MWZyZzZ5In0.VflWoXFyairGf0qz2veNXw';
